import { jsxs as d, jsx as n, Fragment as de } from "react/jsx-runtime";
import { useMemo as se } from "react";
import { a as i, i as ce } from "../../core-DVmjA3_O.js";
import { _ as F } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import he from "../BlockView/index.js";
import le from "../DefaultMessage/index.js";
import ge from "../Description/index.js";
import fe from "../Heading/index.js";
import I from "../InlineView/index.js";
import s from "../ListView/index.js";
import me from "../../hooks/useSpacingToken.js";
import { getSpacingValue as pe, paddingSpacings as _e } from "../../utils/style.js";
import '../../index19.css';const ue = "_container_1wgmw_1", Ce = "_with-centered-content_1wgmw_2", ve = "_with-fixed-height_1wgmw_8", ke = "_with-shadow_1wgmw_13", Oe = "_with-background_1wgmw_17", Be = "_with-border_1wgmw_22", Se = "_with-dark-background_1wgmw_27", be = "_form-variant_1wgmw_32", He = "_before-container_1wgmw_33", Pe = "_content_1wgmw_38", De = "_pending-overlaid_1wgmw_46", ye = "_message_1wgmw_51", Ne = "_with-overflow_1wgmw_56", xe = "_without-padding-overflow_1wgmw_57", Fe = "_with-padding-overflow_1wgmw_61", Ie = "_overflow-container_1wgmw_64", Me = "_filters_1wgmw_71", Ve = "_with-content-well_1wgmw_76", e = {
  container: ue,
  withCenteredContent: Ce,
  withFixedHeight: ve,
  withShadow: ke,
  withBackground: Oe,
  withBorder: Be,
  withDarkBackground: Se,
  formVariant: be,
  beforeContainer: He,
  content: Pe,
  pendingOverlaid: De,
  message: ye,
  withOverflow: Ne,
  withoutPaddingOverflow: xe,
  withPaddingOverflow: Fe,
  overflowContainer: Ie,
  filters: Me,
  withContentWell: Ve
};
function Qe(M) {
  const {
    className: V,
    elementRef: W,
    heading: v,
    withEllipsizedHeading: A,
    headingLevel: c = 3,
    headerIcons: k,
    headerActions: h,
    headerDescription: l,
    withHeaderBorder: L,
    withCenteredHeading: j,
    withCenteredHeaderDescription: z,
    withoutWrapInHeader: O,
    withLargeBreakpointInHeader: B,
    variant: g = "default",
    filters: f,
    footerIcons: S,
    footer: b,
    footerActions: H,
    withFooterBorder: E,
    withoutWrapInFooter: R,
    children: m,
    withContentOverflow: a,
    withContentWell: P,
    empty: p = !1,
    filtered: D = !1,
    pending: _ = !1,
    overlayPending: u,
    errored: C = !1,
    emptyMessage: $,
    filteredEmptyMessage: G,
    pendingMessage: T,
    errorMessage: q,
    withoutMessageIcon: J,
    withCompactMessage: K,
    withBackground: Q,
    withDarkBackground: U,
    withShadow: X,
    withPadding: w,
    withBorder: Y,
    withFixedHeight: Z,
    spacing: t,
    spacingOffset: o = 0,
    withoutSpacingOpticalCorrection: r,
    withCenteredContent: ee,
    withOverflow: te,
    ...oe
  } = M, y = i(v) || i(k) || i(h), ne = y || i(l), ie = i(b) || i(S) || i(H), re = me({
    spacing: t,
    offset: o,
    modes: _e,
    withoutOpticalCorrection: r
  }), N = pe(t, o), ae = a && w ? /* @__PURE__ */ n(
    "div",
    {
      className: e.overflowContainer,
      style: {
        padding: `0 ${N}`,
        margin: `0 calc(-1 * ${N})`
      },
      children: m
    }
  ) : m, x = (m || p || _ || C || D) && /* @__PURE__ */ d(de, { children: [
    /* @__PURE__ */ n(
      le,
      {
        className: e.message,
        pending: _,
        filtered: D,
        errored: C,
        empty: p,
        overlayPending: u,
        emptyMessage: $,
        filteredEmptyMessage: G,
        pendingMessage: T,
        errorMessage: q,
        withoutIcon: J,
        compact: K
      }
    ),
    !p && !C && (!_ || u) && ae
  ] }), we = se(() => O ? "none" : c > 3 ? "sm" : B ? "lg" : "md", [c, B, O]);
  return /* @__PURE__ */ d(
    he,
    {
      ...oe,
      elementRef: W,
      className: F(
        e.container,
        Q && e.withBackground,
        U && e.withDarkBackground,
        X && e.withShadow,
        P && e.withContentWell,
        Z && e.withFixedHeight,
        ee && e.withCenteredContent,
        Y && e.withBorder,
        g === "form" && e.formVariant,
        V
      ),
      spacing: t,
      spacingOffset: o,
      withoutSpacingOpticalCorrection: r,
      withPadding: w,
      beforeContainerClassName: e.beforeContainer,
      before: ne && /* @__PURE__ */ d(
        s,
        {
          spacing: t,
          spacingOffset: o,
          layout: "block",
          withSpacingOpticalCorrection: !0,
          withBackground: g === "form",
          withPadding: g === "form",
          children: [
            y && /* @__PURE__ */ n(
              I,
              {
                spacing: t,
                spacingOffset: o - 1,
                withoutSpacingOpticalCorrection: r,
                wrapBreakpoint: we,
                before: k,
                after: h && /* @__PURE__ */ n(
                  s,
                  {
                    spacing: t,
                    spacingOffset: o - 1,
                    withSpacingOpticalCorrection: !r,
                    children: h
                  }
                ),
                children: /* @__PURE__ */ n(
                  fe,
                  {
                    level: c,
                    ellipsize: A,
                    spacing: t,
                    centerAligned: j,
                    children: v
                  }
                )
              }
            ),
            l && /* @__PURE__ */ n(ge, { withCenteredContent: z, children: l })
          ]
        }
      ),
      after: ie && /* @__PURE__ */ n(
        I,
        {
          spacing: t,
          spacingOffset: o,
          withoutSpacingOpticalCorrection: r,
          before: S,
          after: H,
          wrapBreakpoint: R ? "none" : "lg",
          children: b
        }
      ),
      withBeforeSeparator: L,
      withAfterSeparator: E,
      childrenContainerClassName: F(
        e.content,
        u && e.pendingOverlaid,
        a && e.withOverflow,
        w && a && e.withPaddingOverflow,
        !w && a && e.withoutPaddingOverflow,
        P && re
      ),
      withOverflow: te,
      children: [
        i(f) && /* @__PURE__ */ d(
          s,
          {
            layout: "block",
            spacing: t,
            spacingOffset: o,
            children: [
              /* @__PURE__ */ n(
                s,
                {
                  gridContentClassName: e.filters,
                  layout: "grid",
                  numPreferredGridColumns: 6,
                  spacing: t,
                  spacingOffset: o - 1,
                  children: f
                }
              ),
              x
            ]
          }
        ),
        ce(f) && x
      ]
    }
  );
}
export {
  Qe as default
};
